<template>
  <div>
    <div v-if="list.length > 0">
      <el-row
        v-for="(o, index) in list"
        :key="index"
        style="width: 100%; margin-top: 40px; height: 'auto'"
        type="flex"
      >
        <el-col v-if="o[0]" :span="11" style="background: #F2F6FC;height: 100px;">
          <div @click="goDetail(o[0].pkCommContent)">
            <el-image
            style="
              height: 100px;
              width: 100px;
              display: inline-block;
              float: left;
            "
            :src="o[0].imgUrl"
          ></el-image>
          <span
            style="
              height: 100px;
              width: auto;
              display: inline-block;
              float: left;
              line-height: 100px;
              margin-left: 10px;
              cursor: pointer;
            "
            >
             <template>{{ o[0].title | subStrFilter(0,20)}}</template>
          </span>
          </div>
        </el-col>
        <el-col
          v-if="o[1]"
          :span="11"
          :offset="2"
          style="background: #F2F6FC; height: '100px'"
        >
        <div @click="goDetail(o[1].pkCommContent)">
          <el-image
            style="
              height: 100px;
              width: 100px;
              display: inline-block;
              float: left;
            "
            :src="o[1].imgUrl"
          ></el-image>
          <span
            style="
              height: 100px;
              width: auto;
              display: inline-block;
              float: left;
              line-height: 100px;
              margin-left: 10px;
              cursor: pointer;
            "
            >
             <template >{{ o[1].title | subStrFilter(0,20)}}</template>
          </span>
        </div>
        </el-col>
      </el-row>
      <el-row style="text-align: center; margin-top: 20px">
        <el-pagination
          @current-change="myHandleCurrentChange"
          background
          layout="prev, pager, next"
          :page-size="myPageSize"
          :current-page.sync="myPage"
          :total="myTotal"
        >
        </el-pagination>
      </el-row>
    </div>
    <div v-if="list.length === 0">暂无数据</div>
  </div>
</template>

<script>
export default {
  name: "list",
  props: {
    list: Array,
    pageSize: {
      default: 10,
    },
    page: {
      default: 0,
    },
    total: {
      default: 0,
    },
    handleCurrentChange: Function,
  },
  data() {
      return {
          myPage: this.$props.page,
          myPageSize: this.$props.pageSize,
          myTotal: this.$props.total,
      }
  },
  watch: {
    page: {
      handler (n) {
        this.myPage = n
      },
    },
    pageSize: {
      handler (n) {
        this.myPageSize = n
      },
    },
    total: {
      handler (n) {
        this.myTotal = n
      },
    }
  },
  methods: {
    goDetail(id) {
      this.$router.push({ name: 'detail', query: {
        id: id
      } });
    },
      myHandleCurrentChange() {
          this.$emit('update:page', this.myPage)
          this.$emit('update:pageSize', this.myPageSize)
          this.$emit('update:total', this.myTotal)
          this.$props.handleCurrentChange()
      },
  }
};
</script>
